import React, { createContext, useContext } from 'react';
import { toast } from 'react-toastify';
import { TokenContext } from './TokenContext';
import { apiMensageria } from '../services/api';



export const NotificacaoContext = createContext([]);

export function NotificacaoProvider(props) {
	const { children, user } = props;
	const { autenticacaoV1Token } = useContext(TokenContext);
	async function authToken() {
		let result = null;
		try {
			result = await autenticacaoV1Token();
		} catch (e) {
			console.error(e);
		}
		return result;
	}
	/*
	async function authToken() {
		try {
			const credentials = {
				username: config.USER_AUTHENTICATION_DEV,
				password: config.USER_AUTHENTICATION_PASS_DEV,
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);

			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}

		return null;
	}
	*/

	async function getNotificacoes(all, page) {
		try {
			const response = await apiMensageria.get(`notification/?page=${page}&limit=10&user_id=${user.dados.user_id}&${all}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				});

			return response;
		} catch (error) {
			toast.error(
				'Notificações não carregadas. Por favor atualize a página.'
			);
		}
		return null;
	}

	async function getNotificacaoById(id) {
		try {
			await apiMensageria.get(`notification/${id}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}).then((res) => {
					console.log('getNotificacaoById res', res)
				})
		} catch (error) {
			toast.error(
				'Notificação única não carregadas. Por favor atualize a página.'
			);
		}
		return null;
	}

	async function lerNotificacao(id) {
		try {
			await apiMensageria.post(`notification/${id}/read`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				})
		} catch (error) {
			toast.error(
				'Falha na leitura da notificação. Por favor atualize a página.'
			);
		}
		return null;
	}

	async function lerTodasNotificacoes() {
		try {
			const response = await apiMensageria.post(`notification/${user.dados.user_id}/read-all`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				})
			return response;
		} catch (error) {
			toast.error(
				'Falha na leitura de todas as notificações. Por favor atualize a página.'
			);
		}
		return null;
	}

	async function cancelarNotificacao(id) {
		try {
			await apiMensageria.post(`notification/${id}/cancel`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}).then((res) => {
					console.log('cancelarNotificacao res', res)
				})
		} catch (error) {
			toast.error(
				'Falha no cancelamento de notificação. Por favor atualize a página.'
			);
		}
		return null;
	}

	return (
		<NotificacaoContext.Provider
			value={{
				authToken,
				getNotificacoes,
				getNotificacaoById,
				lerNotificacao,
				cancelarNotificacao,
				lerTodasNotificacoes
			}}>
			{children}
		</NotificacaoContext.Provider>
	);
}
